import { ButtonGreen } from '../shared/Button';
import { HEADER_HEIGHT } from '../../constants/dims';
import imgBg from '../../assets/img/getStartedBg.png';
import { MOBILE_WIDTH } from '../../constants/dims';
import { TABLET_WIDTH } from '../../constants/dims';
import styled from 'styled-components/macro';

export const Section = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.getStartedNow.text};
  background-color: ${props => props.theme.getStartedNow.backgroundColor};
  background-image: url(${imgBg});
  background-repeat: none;
  background-size: cover;
  background-position: center;
  height: ${props =>
    !props.inGame ? `calc(100vh - ${HEADER_HEIGHT}px)` : 'auto'};
  min-height: ${props => (!props.inGame ? '600px' : 'auto')};

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    display: block;
    height: auto;
  }

  @media screen and (max-height: 812px) {
    height: auto;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${TABLET_WIDTH}px;
  text-align: center;
  padding: 32px;
  box-sizing: border-box;
`;

export const StyledGreenButton = styled(ButtonGreen)`
  font-size: 1.5em;
  margin: 12px 0;
  font-weight: 500;
  letter-spacing: normal;
  z-index: 11;
  position: relative;
`;

export const Wuzzits = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    flex-direction: column;
  }

  & > div {
    position: relative;
    width: 100%;
    max-width: 450px;
    margin-bottom: 24px;

    & > div {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      font-style: italic;
      font-size: 1.6em;

      @media screen and (max-width: ${MOBILE_WIDTH}px) {
        position: relative;
      }
    }

    & .wuzzits {
      margin-top: 20px;
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
    }
  }
`;

export const ChildSafe = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    flex-direction: column;
  }

  & > .logo {
    flex: 0 0 220px;
    width: 220px;
    margin: 60px 12px;
    box-sizing: border-box;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      margin: 30px 0;
    }
  }

  & > .left {
    display: flex;
    flex: 1 0 140px;
    font-size: 1.6em;
    line-height: normal;
    text-align: left;
    justify-content: flex-end;
    box-sizing: border-box;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      flex: inherit;
      margin-top: 20px;
      text-align: center;
    }

    & > div > div {
      display: flex;
      align-items: flex-start;

      & .dollar-sign {
        font-size: 3.2em;
        font-style: italic;
      }

      & .dollars {
        font-size: 3.2em;
      }

      & .cents {
        font-size: 1.1em;
        line-height: normal;
        padding-top: 10px;
        padding-left: 6px;
      }
    }
  }

  & > .right {
    flex: 1 0 140px;
    font-size: 1.6em;
    line-height: 1.2em;
    font-weight: bold;
    text-align: right;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      text-align: center;
      font-size: 1.5em;
    }

    & > .number {
      font-size: 1.2em;
      line-height: 1.2em;
      font-weight: bold;
    }
  }
`;
